// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3nGTm","description":"PatientConsentPreview_description__3KM-2"};